import React, { Component } from "react";
import Form from "react-bootstrap/Form";
import "../../stb_styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { CONFIRMATION_TITLE, CONFIRMATION_TEXT, CONFIRMATION_TEXT_RCPA, CONFIRMATION_TEXT_ENV_COMM } from "../../resources/constants/ui";
import { ENVIRONMENTAL_COMMENTS_FORM_TYPE, RCPA_FORM_TYPE } from "../../resources/constants/fields";

class Confirmation extends Component {
	constructor(props) {
		super(props);
		this.state = {
			filingType: props.filingType
		};
	}

	render() {
		return (
			<Form noValidate>
				<div>
					<center>
						<h1>{CONFIRMATION_TITLE}</h1>
					</center>
					<br />
					<hr />
					<br />
					<p>
						{
							this.state.filingType && this.state.filingType === RCPA_FORM_TYPE ? 
							CONFIRMATION_TEXT_RCPA : 
							this.state.filingType && this.state.filingType === ENVIRONMENTAL_COMMENTS_FORM_TYPE ?
							CONFIRMATION_TEXT_ENV_COMM : 
							CONFIRMATION_TEXT
						}
					</p>
					<br />
				</div>
			</Form>
		);
	}
}

export default Confirmation;
